import React from "react"

const Navbar = (props) => {

  // const scroll = () =>{
  //   props.close();
  //   window.scrollTo({
  //     top: document.body.scrollHeight, 
  //     behavior: 'smooth'
  //   });
  // };

  const scroll = (id) =>{
    document.getElementById(id).scrollIntoView({behavior:'smooth',block:'center'});
  };

  const menuItems = [
    {
      menu: "Home", 
      submenu: [],
      onclick: scroll
    },
    {
      menu: "About", 
      submenu: [],
      onclick: scroll
    },
    {
      menu: "Projects", 
      submenu: [],
      onclick: scroll
    },
    {
      menu: "Pages", 
      submenu: [],
      onclick: scroll
    },
    {
      menu: "Skills", 
      submenu: [],
      onclick: scroll
    },
    {
      menu: "Contact", 
      submenu: [],
      onclick: scroll
    }];

  return (
    <nav className="mainmenunav d-lg-block">
            <ul className="mainmenu">
              {menuItems.map((item,i)=>{
                return <li className="has-droupdown show-on-scroll" key={item.menu+i}>
                  <a href={"#"+item.menu} onClick={()=>item.onclick(item.menu+0)}>{item.menu}</a>
                  {item.submenu.length>0 &&
                    <ul className="submenu">
                      {item.submenu.map((subitems,j)=>{
                        return <li key={subitems+j}>
                          <a href={"#"+subitems}>{subitems}</a>
                        </li>
                      })}
                    </ul>
                  }
                </li>
              })}
            </ul>
          </nav>
  )
}

export default Navbar
